/**
 * Users Form - Manejo de formularios de creación y edición de usuarios
 */
import $ from 'jquery';
import 'select2';
export class UsersForm {
    constructor() {
        this.init();
    }
    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.initializeForm();
            });
        }
        else {
            this.initializeForm();
        }
    }
    initializeForm() {
        const userForm = document.getElementById('userForm');
        if (!userForm) {
            return;
        }
        this.setupSelect2();
    }
    setupSelect2() {
        const profileSelect = document.getElementById('id_rol');
        const groupSelect = document.getElementById('id_group');
        const select2Config = {
            theme: 'bootstrap-5',
            width: '100%',
            placeholder: 'Seleccionar...',
            allowClear: true,
            language: {
                noResults: function () {
                    return 'No se encontraron resultados';
                },
                searching: function () {
                    return 'Buscando...';
                },
                inputTooShort: function () {
                    return 'Por favor ingresa 1 o más caracteres';
                }
            }
        };
        // Inicializar Select2 en el dropdown de grupos
        if (groupSelect) {
            $(groupSelect).select2({
                ...select2Config,
                placeholder: 'Seleccionar grupo...'
            });
            // Remover clase de error al cambiar la selección
            $(groupSelect).on('change', function () {
                groupSelect.classList.remove('is-invalid');
                const errorDiv = groupSelect.parentElement?.querySelector('.select2-error');
                if (errorDiv) {
                    errorDiv.remove();
                }
            });
        }
        // Inicializar Select2 en el dropdown de perfiles
        if (profileSelect) {
            $(profileSelect).select2({
                ...select2Config,
                placeholder: 'Seleccionar perfil...',
                allowClear: false
            });
            // Remover clase de error al cambiar la selección
            $(profileSelect).on('change', function () {
                profileSelect.classList.remove('is-invalid');
                const errorDiv = profileSelect.parentElement?.querySelector('.select2-error');
                if (errorDiv) {
                    errorDiv.remove();
                }
            });
        }
    }
}
export default UsersForm;
